import { actions } from "./commonActions";
import { thunks } from "./commonThunks";
import { FirebaseModel, firebaseModel } from "./model-firebase";
import { meModel, MeModel } from "./model-me";
import miscModel, { MiscModel } from "./model-misc";
import { TableModels, tableModels, TableModelSliceName } from "./table-models";
import {
  entitySelectionModel,
  EntitySelectionModel,
} from "./model-entity-selection";
import {
  AdmissionsCoordinatorSelectionModel,
  modelAdmissionsCoordinatorSelection,
} from "./model-ac-selection";
import { DrawerFormModel, drawerFormModel } from "./model-drawer-form";
import {
  EnrollmentCoordinatorSelectionModel,
  modelEnrollmentCoordinatorSelection,
} from "./model-ec-selection";

export interface EmailPassword {
  email: string;
  password: string;
}

// The interface representing our entire store model
export interface StoreModel extends TableModels {
  entitySelection: EntitySelectionModel;
  me: MeModel;
  misc: MiscModel;
  drawerForm: DrawerFormModel;
  firebase: FirebaseModel;
  //
  admissionsCoordinatorSelection: AdmissionsCoordinatorSelectionModel;
  enrollmentCoordinatorSelection: EnrollmentCoordinatorSelectionModel;
}

const model: StoreModel = {
  entitySelection: entitySelectionModel,
  me: meModel,
  firebase: firebaseModel,
  misc: miscModel,
  drawerForm: drawerFormModel,
  //
  admissionsCoordinatorSelection: modelAdmissionsCoordinatorSelection,
  enrollmentCoordinatorSelection: modelEnrollmentCoordinatorSelection,
  //
  ...tableModels,
};

export type BackendConnectedModelSliceName = TableModelSliceName | "me";

export type ModelSliceName =
  | BackendConnectedModelSliceName
  | "firebase"
  | "misc"
  | "drawerForm"
  | "admissionsCoordinatorSelection"
  | "enrollmentCoordinatorSelection";

function isResourceModel(modelSlice) {
  return !!modelSlice.INITIAL_DATA_ENDPOINT;
}

Object.entries(model).forEach(([modelSliceName, modelSlice]) => {
  if (!isResourceModel(modelSlice)) {
    return;
  }

  modelSlice.initialDataReceived = false;
  modelSlice.initialDataLoading = false;

  const myActions = actions();
  [
    "setFetchQueryParams",
    "markInitialDataReceived",
    "markInitialDataNotReceived",
    "markInitialDataLoading",
    "markInitialDataNotLoading",
    "receiveInitialData",
    "clear",
  ].forEach((actionName) => {
    if (!modelSlice[actionName]) {
      modelSlice[actionName] = myActions[actionName];
    }
  });

  const myThunks = thunks(modelSliceName);
  ["handleFetchInitialData", "maybeHandleFetchInitialData"].forEach(
    (thunkName) => {
      if (!modelSlice[thunkName]) {
        modelSlice[thunkName] = myThunks[thunkName];
      }
    }
  );
});

export { model };
